import './AddressCard.scss'

import { DeleteFilled, EditOutlined, EnvironmentOutlined, ExclamationCircleFilled } from '@ant-design/icons'
import { Modal, notification } from 'antd'
import { AppRoutes } from 'App'
import { useAdresSilMutation } from 'gql/GeneratedGraphqlTypes'
import { Adres } from 'gql/StaticTypes'
import { useNavigate } from 'react-router-dom'

interface Props {
  data: Adres
  onDeleted?: () => void
}

const AddressCard: React.FC<Props> = ({ data, onDeleted }) => {
  const [adresSilMutation] = useAdresSilMutation()
  const navigate = useNavigate()

  if (!data) return null

  const { confirm } = Modal

  const showConfirm = (id: number) => {
    confirm({
      title: 'Adresi silmek istediğinize emin misiniz?',
      icon: <ExclamationCircleFilled />,
      content: 'Sildiğiniz adresi geri alamazsınız. Lütfen devam etmek için tamam tuşuna basınız.',
      async onOk() {
        try {
          await adresSilMutation({ variables: { id } })
          notification.open({
            message: 'Başarılı',
            description: 'Adres başarılı bir şekilde silindi.',
            type: 'success',
            placement: 'topRight',
          })
          if (onDeleted) onDeleted()
        } catch {
          notification.open({
            message: 'Hata',
            description: 'Adres silinirken bir hata oluştu.',
            type: 'error',
            placement: 'topRight',
          })
        }
      },
      okButtonProps: { style: { backgroundColor: '#44B365' } },
      cancelButtonProps: { style: { backgroundColor: '#EA524D', color: 'white' } },
    })
  }

  const toTitle = (str?: string | null) => {
    if (!str) return ''
    const lower = str.toLocaleLowerCase('tr-TR')
    return lower.charAt(0).toLocaleUpperCase('tr-TR') + lower.slice(1)
  }

  const handleEdit = () => {
    navigate(`/${AppRoutes.account.root}/${AppRoutes.account.addAddress}`, {
      state: { adres: data },
    })
  }

  return (
    <div className="address-card">
      <div className="header">
        <div className="address-title">
          <EnvironmentOutlined />
          {data.baslik}
        </div>
        <div className="header-actions">
          <div className="address-edit" onClick={handleEdit}>
            <EditOutlined /> Düzenle
          </div>
          <div className="address-delete" onClick={() => showConfirm(data.id)}>
            <DeleteFilled /> Sil
          </div>
        </div>
      </div>

      <div className="address-container">
        <div className="address-content">
          <span>Ad Soyad:</span>
          <span className="address-value">{data.isim}</span>
        </div>
        <div className="address-content">
          <span>GSM:</span>
          <span className="address-value">{data.gsm}</span>
        </div>
        {data.posta_kodu && (
          <div className="address-content">
            <span>Posta Kodu:</span>
            <span className="address-value">{data.posta_kodu}</span>
          </div>
        )}
        <div className="address-content">
          <span>Mahalle:</span>
          <span className="address-value">{toTitle(data.mahalle?.isim)}</span>
        </div>
        <div className="address-content">
          <span>Adres:</span>
          <span className="address-value">
            {data.adres} {toTitle(data.il?.isim)} / {toTitle(data.ilce?.isim)}
          </span>
        </div>
      </div>
    </div>
  )
}

export default AddressCard
